import React from 'react';
import { Select, SelectItem } from '@nextui-org/react';
import useDataStore, { PriceLevel } from '../../../../common/src/stores/useDataStore';
import { useTranslation } from '../../../../common/src/hooks/useTranslation';

interface PriceLevelFilterProps {
  className?: string;
  onLevelChange?: (level: PriceLevel) => void;
}

const PriceLevelFilter: React.FC<PriceLevelFilterProps> = ({
  className,
  onLevelChange,
}) => {
  const { t } = useTranslation('market');
  const { priceLevel, setPriceLevel } = useDataStore();

  const PRICE_LEVELS = {
    market: t('Precio Mercado'),
    fob: t('Retorno FOB'),
    producer: t('Retorno Productor'),
  } as const;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLevel = e.target.value as PriceLevel;
    setPriceLevel(newLevel);
    onLevelChange?.(newLevel);
  };

  return (
    <Select
      label={t('Nivel de Visualización')}
      value={priceLevel}
      onChange={handleChange}
      selectedKeys={[priceLevel]}
      className={className}
      size="sm"
      aria-label={t('Nivel de Visualización')}
    >
      {Object.entries(PRICE_LEVELS).map(([key, label]) => (
        <SelectItem key={key} value={key}>
          {label}
        </SelectItem>
      ))}
    </Select>
  );
};

export default PriceLevelFilter;
